import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MSidebar from './msidebar';
import MHeader from './mheader';


function Main() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

      const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
  
    <div className="fixed inset-0 flex flex-col overflow-hidden">
    {/* Header */}
    <div className='h-[3rem] w-full'>
      <MHeader toggleSidebar={toggleSidebar} />
    </div>
  
    {/* Main content area */}
    <div className='flex flex-1 overflow-hidden'>
      <MSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
      
      {/* Content area - removed overflow-y-auto to let components handle their own scrolling */}
      <div className='flex-1 overflow-y-auto'>
        <Outlet />
      </div>
    </div>

  </div>
  );
}

export default Main;
